import { ColdArticleEntity, TranslationEntity } from '@lglp/prismic-client';
import { schema } from 'normalizr';

import { DocumentType, TranslationType } from '../../../types/document';
import { MEDIA_TYPE } from '../../../types/press-media';
import { toDocType, toMediaType } from '../mapping';
import {
  ArticleEntity,
  BranchActivitiesEntity,
  ContactEntity,
  ContactPageEntity,
  FinancialDebtEntity,
  FinancialKeyFiguresEntity,
  FinancialPressReleaseEntity,
  FinancialPublicationEntity,
  FinancialRatingEntity,
  FooterEntity,
  GouvernanceEntity,
  HeaderEntity,
  HomeEntity,
  HubActualitesEntity,
  NewsroomEntity,
  LaPosteEn4Entity,
  PostmenEntity,
  PublicServiceMissionsEntity,
  SearchPageEntity,
  HubNewsroomEntity,
  HotArticleEntity,
} from './documents';
import {
  MediaPressEntity,
  MediaPressReleaseEntity,
} from './documents/media-press';
import { PressReleaseEntity } from './documents/press-release';

const isTranslation = (type?: string): boolean =>
  type.startsWith('translation_');
/**
 * Normalizr schema representing a document
 */
export const CustomType = new schema.Union(
  {
    [DocumentType.ARTICLE]: ArticleEntity,
    [DocumentType.BRANCH_ACTIVITIES]: BranchActivitiesEntity,
    [DocumentType.CONTACT_PAGE]: ContactPageEntity,
    [DocumentType.CONTACT]: ContactEntity,
    [DocumentType.COLD_ARTICLE]: ColdArticleEntity,
    [DocumentType.FINANCIAL_DEBT]: FinancialDebtEntity,
    [DocumentType.FINANCIAL_KEY_FIGURES]: FinancialKeyFiguresEntity,
    [DocumentType.FINANCIAL_PRESS_RELEASE]: FinancialPressReleaseEntity,
    [DocumentType.FINANCIAL_PUBLICATION]: FinancialPublicationEntity,
    [DocumentType.FINANCIAL_RATING]: FinancialRatingEntity,
    [DocumentType.FOOTER]: FooterEntity,
    [DocumentType.GOUVERNANCE]: GouvernanceEntity,
    [DocumentType.HEADER]: HeaderEntity,
    [DocumentType.HOME]: HomeEntity,
    [DocumentType.HOT_ARTICLE]: HotArticleEntity,
    [DocumentType.HUB_ACTUS]: HubActualitesEntity,
    [DocumentType.HUB_NEWSROOM]: HubNewsroomEntity,
    [DocumentType.NEWSROOM]: NewsroomEntity,
    [DocumentType.LA_POSTE_EN_4]: LaPosteEn4Entity,
    [DocumentType.MEDIA_PRESS]: MediaPressEntity,
    [DocumentType.MEDIA_PRESS_RELEASE]: MediaPressReleaseEntity,
    [DocumentType.POSTMEN]: PostmenEntity,
    [DocumentType.PRESS_RELEASE]: PressReleaseEntity,
    [DocumentType.PUBLIC_SERVICE_MISSIONS]: PublicServiceMissionsEntity,
    [DocumentType.SEARCH_PAGE]: SearchPageEntity,

    [TranslationType.TRANSLATION]: TranslationEntity,
  },
  (entity) => {
    if (
      toDocType(entity?.type) === DocumentType.MEDIA_PRESS &&
      toMediaType(entity?.data?.category) === MEDIA_TYPE.RELEASE
    ) {
      return DocumentType.MEDIA_PRESS_RELEASE;
    } else if (isTranslation(entity?.type)) {
      return TranslationType.TRANSLATION;
    }
    return toDocType(entity?.type);
  }
);

/**
 * Normalizr schema representing an array of documents
 */
export const CustomTypes = [CustomType];
